import { useContext } from 'react';
import InputConfig from '../../../../Components/InputConfig';
import { ConfigContext } from '../../../../Contexts/ConfigContext';
import { UnitsContext } from '../../../../Contexts/UnitsContext';
import { SPLIT_DOC_EDIT_MODES, AB_SPLIT_TEST_CONSTANTS } from '../../../../core/constants';
import NetworkCodeContainer from './NetworkCodeContainer';
import { getCounterpartSectionUnitElseNull } from '../../../../utilities/sectionRefHelpers';
import useCommonStyles from '../../../../commonStyles';
import SwitchInput from '../../../../Components/SwitchInput';
import PageHeading from '../../../../Components/PageHeading';
//mui imports====
import { Chip, Grid, Paper, Typography } from '@mui/material';
import { toast } from 'react-toastify';
//===============
const { CONTROL } = AB_SPLIT_TEST_CONSTANTS.AB_SPLIT_TYPE;

const VideoSectionConfig = () => {
	const { rawConfig, updateRawConfig } = useContext(ConfigContext);
	const { units, siteRawConfig, splitDocEditMode, sectionLevelSplit } = useContext(UnitsContext);
	const isSplitDocPresent = splitDocEditMode !== SPLIT_DOC_EDIT_MODES.CREATE;
	const commonStyleClasses = useCommonStyles();
	// Toggles the isArchived key in Section Unit
	const isArchivedToggle = () => {
		// Checks if the section is participating in a Split, returns error if true
		if (
			sectionLevelSplit.enabled &&
			sectionLevelSplit?.splits[rawConfig.videoSectionId]?.splitPercentage >= 0
		) {
			return toast.error('Cannot archive an Active Section! Please remove the split first.', {
				position: toast.POSITION.BOTTOM_RIGHT
			});
		}
		// Throws error, if section is participatin in A/B Split Test.
		if (rawConfig.abSplitTestData) {
			return toast.error('Cannot archive a section participating in A/B Split Test!', {
				position: toast.POSITION.BOTTOM_RIGHT
			});
		}

		const clonedRawConfig = structuredClone(rawConfig);
		updateRawConfig({ ...clonedRawConfig, isArchived: !clonedRawConfig.isArchived });
	};

	const counterpartSectionUnit = getCounterpartSectionUnitElseNull(units, rawConfig.sectionRef);
	const counterpartSectionName =
		counterpartSectionUnit &&
		(rawConfig.abSplitTestData?.splitType === CONTROL
			? `Experiment: ${counterpartSectionUnit.name}`
			: `Control: ${counterpartSectionUnit.name}`);

	return (
		<Paper className={commonStyleClasses.mainPagePaperMarginStyle}>
			<PageHeading
				headingName=" Video Section"
				headingPath={['Dashboard', 'Framerate', 'Video Section']}
				description="Manage video sections core configurations here, like network codes, section name, etc."
			/>

			<Grid container spacing={1} style={{ height: '60%', width: '90%', marginLeft: '4rem' }}>
				<Grid item xs={12}>
					<SwitchInput
						isObjectEditor={false}
						label="Archive Section"
						directValue={rawConfig.isArchived}
						updateDirectValue={() => {
							isArchivedToggle();
						}}
						containerStyles={{ float: 'right', marginRight: '5rem', width: 'fit-content' }}
					/>
				</Grid>
				{rawConfig.abSplitTestData && (
					<Grid
						item
						xs={12}
						style={{
							display: 'flex',
							justifyContent: 'flex-start',
							marginBottom: '2rem'
						}}
					>
						<Typography
							variant="h6"
							color="primary"
							style={{ margin: '0 2rem 0 0rem', width: '15rem' }}
						>
							A / B Split Tags:
						</Typography>

						<Chip
							label={rawConfig.abSplitTestData.splitType}
							style={{ color: 'white', backgroundColor: 'green' }}
						/>
						<Chip label={counterpartSectionName} color="primary" style={{ marginLeft: '1rem' }} />
					</Grid>
				)}

				<Grid item xs={3}>
					<InputConfig
						label="Video Section Id"
						keyData="videoSectionId"
						object={rawConfig}
						updateObject={updateRawConfig}
						editable={false}
					/>
				</Grid>
				<Grid item xs={3}>
					<InputConfig
						label="Section Name"
						keyData="name"
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
				<NetworkCodeContainer
					siteRawConfig={siteRawConfig}
					rawConfig={rawConfig}
					isSplitDocPresent={isSplitDocPresent}
				/>
			</Grid>
		</Paper>
	);
};

export default VideoSectionConfig;
